var React = require('react');

function BarColor (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("linearGradient",{"id":"linear-gradient-bar","y1":"1","x2":"1","y2":"1","gradientUnits":"objectBoundingBox"},[React.createElement("stop",{"offset":"0","stopColor":"#10f8e4","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#24b0ff","key":1})])),React.createElement("rect",{"width":"100","height":"1","fill":"url(#linear-gradient-bar)","key":1})]);
}

BarColor.defaultProps = {"viewBox":"0 0 600 1","preserveAspectRatio":"none"};

module.exports = BarColor;

BarColor.default = BarColor;
